export const getServerProtocol = (): string => {
  if (process.env.REACT_APP_SERVER_PROTOCOL) {
    return process.env.REACT_APP_SERVER_PROTOCOL
  }
  if (typeof window !== 'undefined' && window?.location?.protocol) {
    return window.location.protocol
  }
  return 'https:'
}
